<script>
import Navbar from "@/components/navbar";
import Services from "@/components/services";
import Team from "@/components/team";
import Blog from "@/components/blog";
import Contact from "@/components/contact";
import Footer from "@/components/footer";
import WebConfiguration from "@/components/WebConfiguration";

/**
 * index-2 component
 */
export default {
  name: "index-2",
  components: {
    Navbar,
    Services,
    Blog,
    Team,
    Contact,
    Footer,
    WebConfiguration,
  },
};
</script>

<template>
  <div>
    <Navbar />
    <div v-scroll-spy>
      <!--START HOME-->
      <section class="section bg-home home-half" id="home"
        :style="{ 'background-image': 'url(' + require('@/assets/images/libertad.jpg') + ')', 'background-size': 'cover', 'background-position': 'center' }">
        <div class="bg-overlay"></div>
        <div class="display-table">
          <div class="display-table-cell">
            <div class="container">
              <div class="row">
                <div class="col-lg-8 offset-lg-2 text-white text-center">
                  <h1 class="home-title">Disfruta de tus viajes protegido VIAJEMOS JUNTOS</h1>
                  <p class="padding-t-15 home-desc">El Seguro en los Estados Unidos para Autos Mexicanos es Requerido por
                    la Ley</p>
                    <div class="text-center mx-auto btn-container">
            <a href="https://public.nhseguros.com/#!policyindividual/index?code=22807&lang=es" target="_blank"
              class="btn btn-custom waves-light waves-effect margin-t-50">
              Comprar poliza
            </a>
          </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="wave-effect wave-anim">
          <div class="waves-shape shape-one">
            <div class="wave wave-one"
              :style="{ 'background-image': 'url(' + require('@/assets/images/wave-shape/wave1.png') + ')' }"></div>
          </div>
          <div class="waves-shape shape-two">
            <div class="wave wave-two"
              :style="{ 'background-image': 'url(' + require('@/assets/images/wave-shape/wave2.png') + ')' }"></div>
          </div>
          <div class="waves-shape shape-three">
            <div class="wave wave-three"
              :style="{ 'background-image': 'url(' + require('@/assets/images/wave-shape/wave3.png') + ')' }"></div>
          </div>
        </div>
        <!--END HOME-->
      </section>
      <!--END HOME-->
      <Team />
      <Blog />
      <Services />
      <WebConfiguration />
      <Contact />
      <Footer />
    </div>
  </div>
</template>

<style scoped>
::v-deep .modal-content {
  background-color: #000000;
  color: white;
  background: none;
  border: none;
}

::v-deep .modal-header {
  border: none;
}

::v-deep .modal-backdrop {
  opacity: 0.5;
}

.btn-container {
  position: relative;
  z-index: 20;
}

.btn-container .btn {
  position: relative;
  z-index: 21;
}
</style>